import headerNavItems from "@/data/header-nav-items-recursive";
import Menubar from "primevue/menubar";

export default {
  name: "header-navbar-recursive",
  components: {
    Menubar
  },
  data() {
    return {
      items: []
    }
  },
  methods: {
    goToScrollWidthEnd(){
      if(this.$refs['menubarDiv'].scrollWidth >= document.documentElement.scrollWidth){
        document.documentElement.scrollLeft = this.$refs['menubarDiv'].scrollWidth;
      }
    },
    verifyAuth(menuItems) {
      return menuItems.map((elm) => {
        if (elm.items == undefined) {
          elm.disabled = !elm.isAuthorize && !this.$isAuthorize(elm.controller, elm.action);
        } else {
          elm.items = this.verifyAuth(elm.items);
        }
        return elm;
      });
    }
  },
  mounted() {
    this.items = this.verifyAuth(headerNavItems);
  }
};


// WEBPACK FOOTER //
// ./src/components/layout/HeaderNavbarRecursive/HeaderNavbarRecursive.js